(function(){

    jQuery('.js-filter-featured-tag').on('click', function(e) {
          e.preventDefault();
  
          if( !jQuery(this).hasClass('active') ) {
              jQuery('.js-filter-featured-tag.active').removeClass('active');
              jQuery(this).addClass('active');
              var active = jQuery(this).data('tid'); 
              var pid = jQuery(this).data('pid'); 
              //jQuery('.loading_layer').addClass('loading');
              
              jQuery.ajax({
                  url: wami_js.ajaxurl,
                  data: {
                      action: "wami_update_featured",
                      active: active,
                      pid: pid,
                  },
                  success: function (data) {
                      // ajouter le remplace du contenu de la div
                      // et si besoin relacer le splide
                      jQuery('.js-slider-content').empty().append(data);

                      var splide = new Splide('#splide-featured', {
                        perPage: 3,
                        arrows: true,
                        breakpoints: {
                            1000: {
                              perPage: 2,
                            },
                            768: {
                              padding: {
                                left: "30px",
                              },
                            },
                            550: {
                              perPage: 1,
                              gap: "1rem",
                            },
                            400: {
                              padding: {
                                right: "4rem",
                              },
                            }
                          },
                          padding: {
                            right: "6rem",
                          },
                      }).mount();
                      
                  },
                  error: function (errorThrown) {
                      console.log("erreur de chargement");
                  },
              }); 
          }
    });
   
})()